import { render, staticRenderFns } from "./StoreAutoAcceptRuleManage.vue?vue&type=template&id=048934ae&scoped=true&"
import script from "./StoreAutoAcceptRuleManage.vue?vue&type=script&lang=js&"
export * from "./StoreAutoAcceptRuleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048934ae",
  null
  
)

export default component.exports